
import { isBuyOperation } from '~/utils/operations';
import { isLimitPriceOrderType, isMarketPriceOrderType } from '~/utils/orders';
import { inAppRedirect, appURLs } from '~/utils/route-redirects';

export default {
  name: 'NotificationOrderCompleted',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  computed: {
    isLimitOrder() {
      return isLimitPriceOrderType(this.notif.portfolioOrderInfo.orderType);
    },
    isMarketOrder() {
      return isMarketPriceOrderType(this.notif.portfolioOrderInfo.orderType);
    },
    isBuy() {
      return isBuyOperation(this.notif.portfolioOrderInfo.operationType);
    },
    notifTextLabelKey() {
      if (this.isLimitOrder) {
        return 'limit_order_completed_notif_label';
      }
      if (this.isMarketOrder) {
        return 'market_order_completed_notif_label';
      }
      throw new Error(
        `Unsupported order type for order completed notification: ${this.notif.portfolioOrderInfo.orderType}`
      );
    },
    notifTextKey() {
      if (this.isLimitOrder) {
        return this.isBuy
          ? 'limit_buy_order_completed_notif_text'
          : 'limit_sell_order_completed_notif_text';
      }
      if (this.isMarketOrder) {
        return this.isBuy
          ? 'market_buy_order_completed_notif_text'
          : 'market_sell_order_completed_notif_text';
      }
      throw new Error(
        `Unsupported order type for order completed notification: ${this.notif.portfolioOrderInfo.orderType}`
      );
    },
    notifTextParams() {
      const info = this.notif.portfolioOrderInfo;
      return {
        operationCashAmount: this.$display.money.moneyWithoutCurrency(
          info.operationCashAmount
        ),
        operationCurrency: this.$display.money.getCurrencySymbol(
          info.operationCurrency
        ),
        orderCompanyName: this.$display.text.truncate(info.companyName, 11),
        operationTickerPrice: this.$display.money.moneyWithoutCurrency(
          info.tickerPrice
        ),
        tickerCurrency: this.$display.money.getCurrencySymbol(
          info.tickerCurrency
        ),
      };
    },
  },
  methods: {
    goToTarget(targetId) {
      if (!targetId) return;

      inAppRedirect(appURLs.portfolioById(targetId));
    },
  },
};
